var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8H13.7574C14.553 8 15.3161 8.31607 15.8787 8.87868L16.1213 9.12132C16.6839 9.68393 17.447 10 18.2426 10H22C22.5523 10 23.0237 10.1953 23.4142 10.5858C23.8047 10.9763 24 11.4477 24 12V23C24 23.5523 23.8047 24.0237 23.4142 24.4142C23.0237 24.8047 22.5523 25 22 25H8C7.44771 25 6.97631 24.8047 6.58579 24.4142C6.19526 24.0237 6 23.5523 6 23V10C6 9.44771 6.19526 8.97631 6.58579 8.58579C6.97631 8.19526 7.44771 8 8 8Z",
    fill: "url(#paint0_linear_5_181)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 23V14C10 13.4477 10.1953 12.9763 10.5858 12.5858C10.9763 12.1953 11.4477 12 12 12H26C26.5523 12 27.0237 12.1953 27.4142 12.5858C27.8047 12.9763 28 13.4477 28 14V23C28 23.5523 27.8047 24.0237 27.4142 24.4142C27.0237 24.8047 26.5523 25 26 25H8C8.55229 25 9.02369 24.8047 9.41421 24.4142C9.80474 24.0237 10 23.5523 10 23Z",
    fill: "url(#paint1_linear_5_181)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_181",
    x1: 15,
    y1: 8,
    x2: 15,
    y2: 19.2436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38DBF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_181",
    x1: 18,
    y1: 12,
    x2: 18,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#306A74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#068FCC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjet);
export default __webpack_public_path__ + "static/media/projet.95121a3d4b022855ff200ca9c776435b.svg";
export { ForwardRef as ReactComponent };